import UserListingView from "./UserListingView";

export default UserListingView;
